import React, { useState } from "react";
import ErrorMessage from "./ErrorMessage";
import { ErrorType } from "../../types/common-type";
import CommonSelect2 from "./commonSelect2";
import { countryOptions } from "../data/js/common-data";

interface ModifyProps {
  handleClose: () => void;
  handleSubmit: (data: any) => void;
}

const ModifyInviteModal: React.FC<ModifyProps> = ({
  handleClose,
  handleSubmit,
}) => {
  const [formData, setFormData] = useState({
    email: "",
    countryCode: "",
    phone: "",
    reason: "",
  });
  const [errors, setErrors] = useState<ErrorType>();

  function handleSubmitModal(e: React.FormEvent) {
    e.preventDefault();
    handleSubmit(formData);
  }

  return (
    <div>
      <div className="modal-backdrop fade show" onClick={handleClose} />
      <div
        className="modal fade show"
        style={{ display: "block" }}
        role="dialog"
        aria-modal="true"
      >
        <div className="modal-dialog modal-dialog-centered modal-lg">
          <div
            className="modal-content mx-auto border-0"
            style={{
              width: "97%",
              maxWidth: 620,
              borderRadius: 16,
              boxShadow: "0 12px 40px rgba(15, 23, 42, 0.18)",
              overflow: "hidden",
            }}
          >
            {/* Header banner */}
            <div
              className="d-flex align-items-center justify-content-between"
              style={{
                background: "linear-gradient(135deg, #F26522 0%, #C6501A 100%)",
                padding: "20px 24px",
              }}
            >
              <div className="d-flex align-items-center gap-3">
                <div
                  className="d-flex align-items-center justify-content-center"
                  style={{
                    width: 42,
                    height: 42,
                    borderRadius: 12,
                    background: "rgba(255,255,255,0.18)",
                  }}
                >
                  <i
                    className="ti ti-mail-forward"
                    style={{ color: "#fff", fontSize: 20 }}
                  />
                </div>
                <div>
                  <h5 className="mb-0" style={{ color: "#fff", fontWeight: 600, fontSize: 17 }}>
                    Modify Invite
                  </h5>
                  <div style={{ color: "rgba(255,255,255,0.85)", fontSize: 12.5 }}>
                    Update applicant details and resend invitation
                  </div>
                </div>
              </div>
              <button
                type="button"
                onClick={handleClose}
                aria-label="Close"
                className="d-flex align-items-center justify-content-center border-0"
                style={{
                  width: 32,
                  height: 32,
                  borderRadius: "50%",
                  background: "#fff",
                  color: "#F26522",
                }}
              >
                <i className="ti ti-x" style={{ fontSize: 14 }} />
              </button>
            </div>

            <div className="modal-body pt-4 px-4 pb-0">
              {/* Instructions */}
              <div
                className="p-3 mb-4 rounded-3"
                style={{ backgroundColor: "#FFF3EC", border: "1px solid #FBD9C4" }}
              >
                <h6
                  className="mb-2 d-flex align-items-center gap-2"
                  style={{ fontWeight: 600, fontSize: 13, color: "#F26522" }}
                >
                  <i className="ti ti-info-circle" style={{ fontSize: 15 }} />
                  Instructions
                </h6>
                <ul
                  className="mb-0 ps-3"
                  style={{ fontSize: 12.5, color: "#5B6472", lineHeight: 1.7 }}
                >
                  <li>Modify the phone number or email, if required.</li>
                  <li>Provide a reason before resending the invite.</li>
                  <li>The applicant will receive a new invitation.</li>
                </ul>
              </div>

              <form onSubmit={handleSubmitModal}>
                {/* Email + Mobile side by side */}
                <div className="row">
                  <div className="col-md-6 mb-3">
                    <label
                      className="form-label"
                      style={{ fontWeight: 600, fontSize: 13, color: "#111827" }}
                    >
                      Email Address
                    </label>
                    <div className="position-relative">
                      <i
                        className="ti ti-mail position-absolute"
                        style={{
                          left: 14,
                          top: "50%",
                          transform: "translateY(-50%)",
                          color: "#9CA3AF",
                          fontSize: 15,
                        }}
                      />
                      <input
                        type="email"
                        className="form-control"
                        name="email"
                        value={formData?.email ?? ""}
                        placeholder="Enter email"
                        onChange={(e) => {
                          setFormData((prev) => ({
                            ...prev,
                            email: e.target.value,
                          }));
                        }}
                        style={{
                          borderRadius: 10,
                          paddingLeft: 38,
                          fontSize: 13.5,
                          height: 42,
                          border: "1px solid #E5E7EB",
                        }}
                      />
                    </div>
                    <ErrorMessage message={errors?.email} />
                  </div>

                  <div className="col-md-6 mb-3">
                    <label
                      className="form-label"
                      style={{ fontWeight: 600, fontSize: 13, color: "#111827" }}
                    >
                      Mobile Number
                    </label>
                    <div className="d-flex gap-2">
                      <div style={{ width: "110px", flexShrink: 0 }}>
                        <CommonSelect2
                          className="select"
                          options={countryOptions}
                          showValue={true}
                          defaultValue={formData?.countryCode ?? ""}
                          onChange={(option: any) => {
                            setFormData((prev) => ({
                              ...prev,
                              countryCode: option.value,
                            }));
                          }}
                        />
                      </div>
                      <input
                        type="text"
                        inputMode="numeric"
                        className="form-control flex-grow-1"
                        name="phone"
                        value={formData?.phone ?? ""}
                        placeholder="e.g. 23894"
                        onChange={(e) => {
                          setFormData((prev) => ({
                            ...prev,
                            phone: e.target.value,
                          }));
                        }}
                        style={{
                          borderRadius: 10,
                          fontSize: 13.5,
                          height: 42,
                          border: "1px solid #E5E7EB",
                        }}
                      />
                    </div>
                    <ErrorMessage message={errors?.phone} />
                  </div>
                </div>

                {/* Reason */}
                <div className="mb-3">
                  <label
                    className="form-label"
                    style={{ fontWeight: 600, fontSize: 13, color: "#111827" }}
                  >
                    Reason for Resending Invite
                  </label>
                  <textarea
                    className="form-control"
                    name="reason"
                    rows={4}
                    maxLength={300}
                    value={formData?.reason ?? ""}
                    placeholder="Please enter the reason..."
                    onChange={(e) => {
                      setFormData((prev) => ({
                        ...prev,
                        reason: e.target.value,
                      }));
                    }}
                    style={{
                      borderRadius: 10,
                      fontSize: 13.5,
                      border: "1px solid #E5E7EB",
                      resize: "none",
                      padding: "10px 14px",
                    }}
                  />
                  <div
                    className="d-flex justify-content-between mt-1"
                    style={{ fontSize: 11, color: "#9CA3AF" }}
                  >
                    <ErrorMessage message={errors?.reason} />
                    <span>{formData?.reason?.length ?? 0}/300</span>
                  </div>
                </div>

                {/* Footer */}
                <div
                  className="modal-footer border-top d-flex justify-content-end gap-2"
                  style={{ padding: "16px 0 20px", marginTop: 8 }}
                >
                  <button
                    type="button"
                    className="btn px-4"
                    onClick={handleClose}
                    style={{
                      borderRadius: 10,
                      fontWeight: 500,
                      fontSize: 13.5,
                      border: "1px solid #E5E7EB",
                      color: "#374151",
                      background: "#fff",
                    }}
                  >
                    Cancel
                  </button>
                  <button
                    type="submit"
                    className="btn px-4 d-inline-flex align-items-center gap-2"
                    style={{
                      borderRadius: 10,
                      fontWeight: 500,
                      fontSize: 13.5,
                      background: "#F26522",
                      color: "#fff",
                      border: "none",
                    }}
                  >
                    <i className="ti ti-send" style={{ fontSize: 14 }} />
                    Send Invite
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ModifyInviteModal;

// import React, { Dispatch, SetStateAction, useState } from "react";
// import ErrorMessage from "./ErrorMessage";
// import { ErrorType } from "../../types/common-type";
// import CommonSelect2 from "./commonSelect2";
// import { countryOptions } from "../data/js/common-data";

// interface ModifyProps {
//   handleClose: () => void;
//   handleSubmit: (data: any) => void;
// }

// const ModifyInviteModal: React.FC<ModifyProps> = ({
//   handleClose,
//   handleSubmit,
// }) => {
//   const [formData, setFormData] = useState({
//     email: "",
//     countryCode: "",
//     phone: "",
//   });
//   const [errors, setErrors] = useState<ErrorType>();

//   function handleSubmitModal() {
//     handleSubmit(formData);
//   }

//   return (
//     <div>
//       <div className="modal-backdrop fade show" onClick={handleClose} />
//       <div
//         className="modal fade show"
//         style={{ display: "block" }}
//         role="dialog"
//         aria-modal="true"
//       >
//         <div className="modal-dialog modal-dialog-centered modal-lg">
//           <div
//             className="modal-content mx-auto"
//             style={{ width: "97%", maxWidth: 500 }}
//           >
//             <div className="modal-header d-flex justify-content-end ">
//               <button
//                 type="button"
//                 className="btn-close custom-btn-close"
//                 onClick={handleClose}
//                 aria-label="Close"
//               >
//                 <i className="ti ti-x" />
//               </button>
//             </div>

//             <div className="modal-body pb-0 py-0 pt-3 px-md-4 ">
//               <div
//                 className="p-3 mb-3 rounded-2 "
//                 style={{ backgroundColor: "#FDF3F4" }}
//               >
//                 <h2>
//                   <i
//                     className="ti ti-edit me-2"
//                     style={{ color: "#EA868F" }}
//                   ></i>
//                   Instructions
//                 </h2>
//                 <ul className="list-style-disc text-gray mt-2">
//                   <li className="mb-1">
//                     <i className="ti ti-point me-1"></i>Use this option to
//                     resend an invite to applicants.
//                   </li>
//                   <li>
//                     <i className="ti ti-point me-1"></i>You can modify the phone
//                     number and email id.
//                   </li>
//                 </ul>
//               </div>
//               <h4 className="modal-title">Modify Invite</h4>
//               <form onSubmit={handleSubmitModal}>
//                 <div className="px-sm-2 ">
//                   <div className="mb-3 mt-3">
//                     <label className="form-label">Email ID</label>
//                     <div className="">
//                       <input
//                         type="email"
//                         className="form-control mb-2"
//                         name="email"
//                         value={formData?.email ?? ""}
//                         placeholder="Enter Email"
//                         onChange={(e) => {
//                           setFormData((prev) => ({
//                             ...prev,
//                             email: e.target.value,
//                           }));
//                         }}
//                       />
//                       <ErrorMessage message={errors?.email} />
//                     </div>
//                   </div>

//                   <div className="mb-3 mt-3">
//                     <label className="form-label">Mobile Number</label>
//                     <div className="input-group">
//                       <div style={{ width: "120px" }}>
//                         <CommonSelect2
//                           className="select "
//                           options={countryOptions}
//                           showValue={true}
//                           defaultValue={formData?.countryCode ?? ""}
//                           onChange={(option: any) => {
//                             setFormData((prev) => ({
//                               ...prev,
//                               countryCode: option.value,
//                             }));
//                           }}
//                         />
//                       </div>
//                       <input
//                         type="text"
//                         inputMode="numeric"
//                         className="ms-1 form-control mb-2"
//                         name="phone"
//                         value={formData?.phone ?? ""}
//                         placeholder="eg: 23894"
//                         onChange={(e) => {
//                           setFormData((prev) => ({
//                             ...prev,
//                             phone: e.target.value,
//                           }));
//                         }}
//                       />
//                       <ErrorMessage message={errors?.phone} />
//                     </div>
//                   </div>
//                 </div>
//                 <div className="modal-footer border-top ">
//                   <button
//                     type="submit"
//                     className="btn btn-secondary px-4 py-1 me-1"
//                   >
//                     Cancel
//                   </button>
//                   <button type="submit" className="btn btn-primary px-4 py-1 ">
//                     Send
//                   </button>
//                 </div>
//               </form>
//             </div>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default ModifyInviteModal;
